var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"header-transparency":true,"show-top-header":false,"footer-style":6}},[_c('div',{staticClass:"demo-slider-area slider-area bg-transparent slider-style-1 pb--100 pt--70"},[_c('div',{staticClass:"container",staticStyle:{"margin-top":"10%","text-align":"center"}},[_vm._v(" 网站建设中,敬请期待! ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }